// extracted by mini-css-extract-plugin
export var endGameContainer = "EndGame-module--endGameContainer--1lcSB";
export var gameEndTitle = "EndGame-module--gameEndTitle--19R2d";
export var restartButton = "EndGame-module--restartButton--gBszY";
export var homeButton = "EndGame-module--homeButton--1Jyyy";